import * as React from "react";
import {useTranslation} from "react-i18next";
import {useId} from "@fluentui/react-hooks";
import {TooltipHost, type ITooltipHostStyles} from "@fluentui/react";
import type IsaacTranslatedTextProps from "./IsaacTranslatedTextProps";

const calloutProps = {gapSpace: 0};
const hostStyles: Partial<ITooltipHostStyles> = {
  root: {display: "inline-block"},
};

const IsaacTranslatedText: React.FC<IsaacTranslatedTextProps> = ({
  value = "",
  parent = "",
  showTooltip = true,
  tooltipValue,
}) => {
  const {t, i18n} = useTranslation();
  const tooltipId = useId("tooltip");
  const reverseLanguage = i18n.language === "en" ? "code" : "en";

  // Construct the translation key as <context>.<fieldName> or just <fieldName>
  const translationKey = parent ? `${parent}.${value}` : value;

  if (!showTooltip) {
    return <>{t(translationKey)}</>;
  }

  // For tooltip, use the same key in the reverse language
  const tooltipContent = tooltipValue ?? t(translationKey, {lng: reverseLanguage});

  return (
    <TooltipHost content={tooltipContent} id={tooltipId} calloutProps={calloutProps} styles={hostStyles}>
      {t(translationKey)}
    </TooltipHost>
  );
};

IsaacTranslatedText.displayName = "TranslatedText";

export default IsaacTranslatedText;
